module.exports = __webpack_public_path__ + "static/whale-watching-3ec07d289c60f2f903fe7993f4dcc2ba.jpg";